/**
 * Compact house TTS chips — Kokoro (standard) + Breeze (premium).
 */
import { memo } from "react";

import {
  houseTtsEngines,
  type HouseTtsEngine,
} from "../lib/houseEngines";

type Props = {
  selectedId: string;
  onSelect: (engine: HouseTtsEngine) => void;
  isMember: boolean;
};

export const HouseEngineChips = memo(({ selectedId, onSelect, isMember }: Props) => {
  return (
    <div className="vf-house" role="group" aria-label="TTS engines">
      <div className="vf-house-row">
        <span className="vf-house-label">Standard</span>
        {houseTtsEngines("standard").map((e) => (
          <button
            key={e.id}
            type="button"
            className={`vf-house-chip${selectedId === e.id ? " vf-house-chip--on" : ""}`}
            title={e.blurb}
            onClick={() => onSelect(e)}
          >
            {e.label}
          </button>
        ))}
      </div>
      <div className="vf-house-row">
        <span className="vf-house-label">Premium</span>
        {houseTtsEngines("premium").map((e) => {
          const locked = Boolean(e.memberOnly) && !isMember;
          return (
            <button
              key={e.id}
              type="button"
              className={`vf-house-chip vf-house-chip--prem${selectedId === e.id ? " vf-house-chip--on" : ""}${locked ? " vf-house-chip--locked" : ""}`}
              title={locked ? `${e.blurb} · Member` : e.blurb}
              onClick={() => onSelect(e)}
            >
              {e.label}
              {locked ? " · M" : ""}
            </button>
          );
        })}
      </div>
    </div>
  );
});

HouseEngineChips.displayName = "HouseEngineChips";
